import { type JSX } from "react";
import { OfferEditableWrap } from "@/components/ClientOfferView";
import styles from "@/components/ClientOfferView.module.css";
import type { OfferSectionProps } from "@/components/offer/offerDocumentTypes";
import { normalizeAssumptions } from "@/components/offer/offerDocumentUtils";

export function AssumptionsSection({ offerData }: OfferSectionProps): JSX.Element | null {
  const assumptions = normalizeAssumptions(offerData.offerAssumptions);
  const onChange = offerData.onOfferAssumptionsChange;

  if (assumptions.length === 0 && !onChange) return null;

  return (
    <section className={styles.assumptions}>
      <div>
        <h2 className={styles.assumptionsHeading}>
          Założenia
          <br />i warunki
          <br />
          oferty
        </h2>
      </div>
      <ul className={styles.assumptionsList}>
        {assumptions.map((item, idx) => (
          <li
            key={`${item}-${idx}`}
            className={`${styles.assumptionItem} ${onChange ? styles.assumptionItemEditable : ""}`}
          >
            <span className={styles.assumptionBullet}>{String(idx + 1).padStart(2, "0")}</span>
            {onChange ? (
              <div className={styles.assumptionItemContent}>
                <OfferEditableWrap enabled className={styles.assumptionEditableWrap}>
                  <span
                    contentEditable
                    spellCheck={false}
                    suppressContentEditableWarning
                    className={styles.assumptionItemText}
                    onBlur={(e) => {
                      const trimmed = e.currentTarget.textContent?.trim() ?? "";
                      const next = assumptions.filter((_, i) => i !== idx);
                      if (trimmed) next.splice(idx, 0, trimmed);
                      onChange(next);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        e.currentTarget.blur();
                      }
                    }}
                  >
                    {item}
                  </span>
                </OfferEditableWrap>
                <button
                  type="button"
                  className={styles.assumptionItemDelete}
                  onClick={() => onChange(assumptions.filter((_, i) => i !== idx))}
                  aria-label={`Usuń założenie ${idx + 1}`}
                  title="Usuń"
                >
                  ×
                </button>
              </div>
            ) : (
              <span>{item}</span>
            )}
          </li>
        ))}
        {onChange ? (
          <li className={styles.assumptionItem}>
            <button
              type="button"
              className={styles.assumptionAddBtn}
              onClick={() => {
                const value = window.prompt("Dodaj założenie");
                if (typeof value !== "string") return;
                const trimmed = value.trim();
                if (!trimmed) return;
                onChange([...assumptions, trimmed]);
              }}
            >
              + Dodaj założenie
            </button>
          </li>
        ) : null}
      </ul>
    </section>
  );
}
